export const operationalApi = {
  deliveryHome: 'config/r/CO/v1/property/DELIVERY_HOME',
};